import { useState } from "react"

import { StaffLayout } from "@/components/layouts/staff-layout"
import {
  MenuGrid,
  type MenuGridCategory,
  type MenuGridItem,
} from "@/components/features/menu/menu-grid"
import { MainContainer } from "@/components/ui/container"
import { MenuItemDetailDrawer } from "@/features/staff/menu-item-detail-drawer"

type Props = {
  categories: MenuGridCategory[]
  orphanItems: MenuGridItem[]
}

export default function StaffLocationMenuShow({ categories, orphanItems }: Props) {
  const [selectedItem, setSelectedItem] = useState<MenuGridItem | null>(null)
  const [drawerOpen, setDrawerOpen]     = useState(false)

  const handleItemClick = (item: MenuGridItem) => {
    setSelectedItem(item)
    setDrawerOpen(true)
  }

  return (
    <StaffLayout>
      <MainContainer size="md">
        <div className="space-y-8" data-testid="staff-menu-view">
          <MenuGrid
            categories={categories}
            orphanItems={orphanItems}
            onItemClick={handleItemClick}
          />
        </div>
      </MainContainer>

      <MenuItemDetailDrawer
        item={selectedItem}
        open={drawerOpen}
        onOpenChange={(open) => {
          setDrawerOpen(open)
          if (!open) setSelectedItem(null)
        }}
      />
    </StaffLayout>
  )
}
